import {
  API_ENDPOINT,
  useClientApiV1AccountsNotificationUpdateMutation,
} from '../../resources/@types/accountSchema';

function useClientAccountNotificationUpdateMutation(
  options?: Parameters<typeof useClientApiV1AccountsNotificationUpdateMutation>[0]['options'],
) {
  return useClientApiV1AccountsNotificationUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_ACCOUNTS_NOTIFICATION,
    options,
  });
}

export default useClientAccountNotificationUpdateMutation;
